<div [hidden]="!viewCondition" [style.grid-row]="gridRow" [style.grid-column]="gridColumn" class="grid-item">
  @for (child of children; track child) {
    <ng-template #children></ng-template>
  }
</div>
